/**
 * Copyright (C) Boost commerce
 * This file is part of commercial Boost commerce projects
 *
 * This file can not be copied and/or distributed without the express
 * permission of Boost commerce
 *
 * Created on Sat Jul 01 2023 00:15:50
 */
// @flow
import { getJSON } from 'redux-api-middleware';
import { I18n } from '@shopify/react-i18n';
import { processRes } from 'src/helpers/actions-helper';
import apiService from 'src/services/api-service';
import {
  GET_CSAT_ADMIN_APP_DISPLAY_REQUEST,
  GET_CSAT_ADMIN_APP_DISPLAY_SUCCESS,
  GET_CSAT_ADMIN_APP_DISPLAY_FAILURE,
  CLOSE_FEEDBACK_WIDGET_REQUEST,
  CLOSE_FEEDBACK_WIDGET_SUCCESS,
  CLOSE_FEEDBACK_WIDGET_FAILURE,
  CREATE_CSAT_FEEDBACK_REQUEST,
  CREATE_CSAT_FEEDBACK_FAILURE,
  CREATE_CSAT_FEEDBACK_SUCCESS
} from 'stores/flow-type/csat-feedback.type';

/**
 * Get csat status for admin app display
 * @param {*} i18n
 * @returns
 */
export const getCSATAdminAppDisplay = (i18n: I18n) => {
  return apiService.sendRequest('admin-v3.csat-feedback.get-csat-admin-app-display', {}, [
    GET_CSAT_ADMIN_APP_DISPLAY_REQUEST,
    {
      type: GET_CSAT_ADMIN_APP_DISPLAY_SUCCESS,
      payload: async (action, state, response) => {
        const data = await getJSON(response);
        return { data };
      }
    },
    {
      type: GET_CSAT_ADMIN_APP_DISPLAY_FAILURE,
      payload: async (action, state, response) => {}
    }
  ]);
};

/**
 * Close CSAT feedback widget
 * @param {*} i18n
 * @returns
 */
export const closeCSATFeedbackWidget = (body: Object, i18n: I18n) => {
  return apiService.sendRequest('admin-v3.csat-feedback.close-csat-feedback-widget', { body }, [
    CLOSE_FEEDBACK_WIDGET_REQUEST,
    {
      type: CLOSE_FEEDBACK_WIDGET_SUCCESS,
      payload: async (action, state, response) => {
        const data = await getJSON(response);
        return { data };
      }
    },
    {
      type: CLOSE_FEEDBACK_WIDGET_FAILURE,
      payload: async (action, state, response) => {}
    }
  ]);
};

/**
 * Send CSAT feedback
 * @param {*} body
 * @param {*} i18n
 * @returns
 */
export const sendCSATFeedback = (body: Object, i18n: I18n) => {
  return apiService.sendRequest('admin-v3.csat-feedback.create-csat-feedback', { body }, [
    CREATE_CSAT_FEEDBACK_REQUEST,
    {
      type: CREATE_CSAT_FEEDBACK_FAILURE,
      payload: async (action, state, response) => {
        const result = await processRes(
          response,
          'custom',
          i18n.translate('AdminHTML.Common.SupportTicketActions.sendSupportTicket_Success'),
          i18n
        );

        return { ...result };
      }
    },
    {
      type: CREATE_CSAT_FEEDBACK_SUCCESS,
      payload: async (action, state, response) => {
        await processRes(
          response,
          'custom',
          i18n.translate('AdminHTML.Common.SupportTicketActions.sendSupportTicket_Failure'),
          i18n
        );
      }
    }
  ]);
};
